import headerImg from "assets/images/v146/header.webp"
import infoImg from "assets/images/v146/info.webp"

export const v146Config = {
  header: { en: headerImg },
  info: { en: infoImg },
}
